import React from "react";
import {
  Typography,
  Box,
  Stack,
  Paper,
  IconButton,
  ButtonBase,
  Chip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { handleCopy } from "../../utils/helper/appHelpers";

export default function ComplaintDetails({ complaintInfo }) {
  const ticket = complaintInfo?.ticket;
  const user = ticket?.user;

  return (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 1 }}>
      
      <Typography variant="subtitle2" gutterBottom>
        Customer Name
      </Typography>
      <Typography variant="body2" color="#138118" mb={2}>
        {user?.userName || "-"}
      </Typography>

      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Typography variant="subtitle2">Contact Information</Typography>
      </Stack>

      {/* Email */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <ButtonBase>
          <Typography variant="body2" color="#138118">
            {user?.email || "-"}
          </Typography>
        </ButtonBase>
        {user?.email && (
          <IconButton
            size="small"
            onClick={() =>
              handleCopy({ message: "Email", text: user.email })
            }
          >
            <ContentCopyIcon sx={{ fontSize: 15 }} />
          </IconButton>
        )}
      </Box>

      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <ButtonBase>
          <Typography variant="body2" color="#138118">
            {user?.dialCode} {user?.mobileNo}
          </Typography>
        </ButtonBase>
        {user?.mobileNo && (
          <IconButton
            size="small"
            onClick={() =>
              handleCopy({
                message: "Phone",
                text: `${user?.dialCode} ${user?.mobileNo}`,
              })
            }
          >
            <ContentCopyIcon sx={{ fontSize: 15 }} />
          </IconButton>
        )}
      </Box>

      <Typography variant="subtitle2" gutterBottom>
        Complaint Details
      </Typography>

      <Stack spacing={1}>
        <Typography variant="body2">
          <b>Complaint ID:</b> {ticket?._id}
        </Typography>

        <Typography variant="body2">
          <b>Category:</b> {ticket?.supportCategoryDetail?.name || "-"}
        </Typography>

        <Typography variant="body2">
          <b>Description:</b> {ticket?.description || "-"}
        </Typography>

        <Typography variant="body2">
          <b>Created On:</b>{" "}
          {new Date(ticket?.createdAt).toLocaleString()}
        </Typography>

       <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body2">
            <b>Status:</b>
        </Typography>

        <Chip
            label={ticket?.status}
            size="small"
            color={
            ticket?.status === "OPEN"
                ? "warning"
                : ticket?.status === "RESOLVED"
                ? "success"
                : ticket?.status === "CLOSED"
                ? "default"
                : "info"
            }
        />
        </Stack>
      </Stack>
      <Box mt={3}>
        <Typography variant="subtitle2" gutterBottom>
          Order / Service Info
        </Typography>

        <Typography variant="body2">
          <b>Order No:</b> {ticket?.orderdetail?.orderNo || "-"}
        </Typography>

        <Typography variant="body2">
          <b>Service:</b> {ticket?.servicemaster?.name || "-"}
        </Typography>
      </Box>
    {/* <Box mt={3}>
    <Typography variant="subtitle2" gutterBottom>
        Shop Details
    </Typography>
     <Typography variant="body2">
        <b>Shop Id:</b> {ticket?.shopId || "-"}
    </Typography>

    <Typography variant="body2">
        <b>Shop Name:</b> {ticket?.shop?.shopName || "-"}
    </Typography>

    <Typography variant="body2">
        <b>City:</b> {ticket?.shop?.city || "-"}
    </Typography>

    <Typography variant="body2">
        <b>State:</b> {ticket?.shop?.state || "-"}
    </Typography>

    <Typography variant="body2">
        <b>Address:</b> {ticket?.shop?.address || "-"}
    </Typography>
    </Box> */}


    </Paper>
  );
}
